import Vue from 'vue'
import { AUTH } from '@/api'
import router from '@/router'
import VueAuth from '@websanova/vue-auth'

Vue.router = router

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: { name: 'login' },
  notFoundRedirect: { name: 'home' },
  tokenDefaultName: 'access_token',
  rolesVar: 'group',
  loginData: { url: AUTH.LOGIN },
  logoutData: { url: AUTH.LOGOUT },
  refreshData: { url: AUTH.REFRESH },
  fetchData: { url: AUTH.USER }
})
